export default __webpack_public_path__ + "static/media/6.8f4c38eb.png";